import { render, staticRenderFns } from "./Donor.vue?vue&type=template&id=29453244&scoped=true&"
import script from "./Donor.vue?vue&type=script&lang=js&"
export * from "./Donor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29453244",
  null
  
)

export default component.exports